// Module
var code = `<div class="pb-5"> <h3 ng-show="\$ctrl.headline" class="text-lg leading-6 font-medium text-gray-900 mb-2" translate>{{\$ctrl.headline}}</h3> <p ng-show="\$ctrl.description" class="max-w-prose text-sm text-gray-500" translate>{{\$ctrl.description}}</p> </div>`;
// Exports
export default code;